var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"id":"page-header"}},[(_vm.managedCompanies > 1)?_c('CompanyInfoChip'):_vm._e(),_c('h1',[_vm._v(_vm._s(_vm.pageTitle))]),(_vm.pageDescription && _vm.pageDescription !== '')?_c('span',{attrs:{"id":"page-intro"}},[_vm._v(_vm._s(_vm.pageDescription))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }